/** The desktop's sample realm (2 MB), built into the app and fetched only when asked for, so never kept offline. */
export const SAMPLE_REALM_PATH = 'samples/the-kingdom-of-asteria.realmery';
